import {
  AccountRelatedPath,
  getAccountRelatedUrl,
  PaginationQueryParams,
} from '@/config/urls'
import { composePathAndParams, joinValues } from '@/utils/urls'

export enum ProjectsTypeSelection {
  'ALL' = 'ALL',
  'ENVIRONMENTS_ONLY' = 'ENVIRONMENTS_ONLY',
  'REPOSITORIES_ONLY' = 'REPOSITORIES_ONLY',
}

export const securityUrls = {
  getSecurityInsightsOverall: ({
    workspaceId,
    params,
  }: AccountRelatedPath & { params?: PaginationQueryParams }): string => {
    const path = joinValues(
      getAccountRelatedUrl(workspaceId),
      'security/insights/overall'
    )
    return composePathAndParams(path, params)
  },
  getSecurityInsightsProjectList: ({
    workspaceId,
    params,
  }: AccountRelatedPath & {
    params?: PaginationQueryParams & { not_scanned_only?: boolean }
  }): string => {
    const path = joinValues(
      getAccountRelatedUrl(workspaceId),
      'security/insights/list/by_project'
    )
    return composePathAndParams(path, params)
  },
  getSecurityInsightsRuleTags: ({
    workspaceId,
    params,
  }: AccountRelatedPath & { params?: PaginationQueryParams }): string => {
    const path = joinValues(
      getAccountRelatedUrl(workspaceId),
      'security/insights/list/by_rule_tag'
    )
    return composePathAndParams(path, params)
  },
  getSecurityInsightsRule: ({
    workspaceId,
    params,
  }: AccountRelatedPath & { params?: PaginationQueryParams }): string => {
    const path = joinValues(
      getAccountRelatedUrl(workspaceId),
      'security/insights/list/by_rule'
    )
    return composePathAndParams(path, params)
  },
}
